module.exports = __webpack_public_path__ + "img/pr-8.12cbe382.png";